module.exports = __webpack_public_path__ + "media/images/motorcycle-9f76549685530f741725da30082b7c64.png";